export const SERVICE_WORKER_CACHE_VERSION = 'WETAGAPP-04112026-2';
